<script lang="ts">
  import Goal from "./Goal.svelte"
  import _ from "lodash"
  import { Plus, Minus } from "lucide-svelte"
  import { slide } from "svelte/transition"

  let props = $props()

  let {
    department,
    weeklyQuarters
  }: {
    department: DepartmentType & {
      goals: any[]
      next_quarter_goals: any[]
    }
    weeklyQuarters: {
      start_quarter: number
      end_quarter: number
      transition_week: boolean
    }
  } = props

  let expanded = $state(true)

  let no_goals =
    department.goals?.length === 0 &&
    department.next_quarter_goals?.length === 0
</script>

<div class="mb-5 shadow-xl rounded-lg">
  <div
    role="button"
    tabindex="0"
    class="flex justify-between hover:cursor-pointer p-4 bg-quarterly-goal rounded-tl rounded-tr"
    data-name="department-item"
    data-department_id={department.id}
    onclick={() => {
      expanded = !expanded
    }}
    onkeydown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        expanded = !expanded
      }
    }}
  >
    <div class="text-2xl font-bold" data-name="department-name">
      {department.name}
    </div>
    <div class="flex items-center text-2xl">
      {#if expanded}
        <Minus class="text-gray-500 w-8 h-8 mr-1" />
      {:else}
        <Plus class="text-gray-500 w-8 h-8 mr-1" />
      {/if}
    </div>
  </div>
  {#if expanded}
    <div
      transition:slide
      class="py-3 px-2 border-l-4 border-quarterly-goal bg-white"
    >
      {#if no_goals}
        <div class="ml-4">
          <p class="text-xl">No Goals for this department</p>
        </div>
      {:else}
        <div class="ml-4">
          {#if weeklyQuarters.transition_week && department.goals.length > 0}
            <div class="bg-gray-50 rounded-sm px-4 py-2 mb-3">
              <h3 class="text-lg italic">
                Please ensure the following goals from <span class="font-bold"
                  >Q{weeklyQuarters.start_quarter}</span
                > are finalized:
              </h3>
            </div>
          {/if}
          {#each _.sortBy(department.goals, "assignee_position") as goal, idx (goal.id)}
            <div class="mb-2">
              <Goal {goal} pos={idx + 1} />
            </div>
          {/each}
          {#if weeklyQuarters.transition_week}
            <div class="mt-4">
              <div class="bg-gray-50 rounded-sm px-4 py-2 mb-3">
                <h3 class="text-xl">
                  Your new goals for <span class="font-bold"
                    >Q{weeklyQuarters.end_quarter}</span
                  >:
                </h3>
              </div>
              {#each _.sortBy(department.next_quarter_goals, "assignee_position") as goal, idx (goal.id)}
                <div class="mb-2">
                  <Goal {goal} pos={idx + 1} />
                </div>
              {:else}
                <div class="bg-yellow-50 py-2 px-4 rounded-sm">
                  <p class="text-lg italic">
                    You have not yet created any <span class="font-bold"
                      >Q{weeklyQuarters.end_quarter}</span
                    > goals for this department
                  </p>
                </div>
              {/each}
            </div>
          {/if}
        </div>
      {/if}
    </div>
  {/if}
</div>
